import { useState, useCallback } from 'react';

export const usePopup = () => {
  const [popups, setPopups] = useState([]);
  
  const showPopup = useCallback(({ type = 'info', title, message, duration = 5000, position = 'top-right' }) => {
    const id = Date.now() + Math.random();
    const popup = {
      id,
      type,
      title,
      message,
      duration,
      position,
      isOpen: true
    };
    
    setPopups(prev => [...prev, popup]);
    
    return id;
  }, []);
  
  const hidePopup = useCallback((id) => {
    setPopups(prev => prev.filter(popup => popup.id !== id));
  }, []);
  
  const showSuccess = useCallback((message, title = 'Success') => {
    return showPopup({ type: 'success', title, message });
  }, [showPopup]);
  
  const showError = useCallback((message, title = 'Error') => {
    return showPopup({ type: 'error', title, message });
  }, [showPopup]);
  
  const showInfo = useCallback((message, title = 'Information') => {
    return showPopup({ type: 'info', title, message });
  }, [showPopup]);
  
  const showWarning = useCallback((message, title = 'Warning') => {
    return showPopup({ type: 'warning', title, message });
  }, [showPopup]);
  
  return {
    popups,
    showPopup,
    hidePopup,
    showSuccess,
    showError,
    showInfo,
    showWarning
  };
};